module.exports = __webpack_public_path__ + "static/media/grass.ea774214.png";